export default __webpack_public_path__ + "static/media/regressiongames_black.97e7a31e.png";